export function trackById<T extends { id: number }>(t: T): number {
  return t.id;
}
